import React, { useState } from "react";

import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import ValidationError from "../validationError";
import { baseRequest } from "../../axiosconfig";
import Loading from "../loading";

export default function ChangePassword() {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  return (
    <div className="login-form-wrapper">
      {!success && (
        <>
          <div className="text-regular">
            <p style={{ fontWeight: "700" }}>Promena lozinke</p>
          </div>
          <Formik
            initialValues={{
              current_password: "",
              password: "",
              password_confirmation: "",
            }}
            validateOnChange={false}
            validationSchema={Yup.object({
              current_password: Yup.string().required("Trenutna lozinka je obavezna"),
              password: Yup.string()
                .min(6, "Lozinka mora imati najmanje 6 karaktera")
                .required("Nova lozinka je obavezna"),
              password_confirmation: Yup.string()
                .oneOf([Yup.ref("password"), null], "Lozinke se ne poklapaju")
                .required("Ponovljena lozinka je obavezna"),
            })}
            onSubmit={async (values, { setFieldError }) => {
              setLoading(true);
              baseRequest
                .post("/change-password", {
                  current_password: values.current_password,
                  password: values.password,
                  password_confirmation: values.password_confirmation,
                })
                .then(() => {
                  setLoading(false);
                  setSuccess(true);
                })
                .catch((error) => {
                  setLoading(false);
                  const errors = error.response?.data?.errors;
                  if (errors) {
                    Object.keys(errors).forEach((field) => {
                      setFieldError(field, errors[field]);
                    });
                  } else {
                    setFieldError(
                      "current_password",
                      "Promena lozinke trenutno nije moguća. Pokušajte ponovo."
                    );
                  }
                });
            }}
          >
            {({ errors }) => (
              <Form className="login-form">
                <div className="login-form-field-wrapper">
                  <label htmlFor="current_password" className="login-form-field-label">
                    Trenutna lozinka:*
                  </label>
                  <Field
                    name="current_password"
                    type={showCurrentPassword ? "text" : "password"}
                    className="login-textfield"
                  />
                  <button
                    className="show-password-button"
                    type="button"
                    onClick={() => setShowCurrentPassword((state) => !state)}
                  >
                    <img src="/images/showpassword.png" alt="" />
                    {showCurrentPassword && <span className="slash"></span>}
                  </button>
                  {errors.current_password && (
                    <ValidationError error={errors.current_password} />
                  )}
                </div>
                <div className="login-form-field-wrapper">
                  <label htmlFor="password" className="login-form-field-label">
                    Nova lozinka:*
                  </label>
                  <Field
                    name="password"
                    type={showPassword ? "text" : "password"}
                    className="login-textfield"
                  />
                  <button
                    className="show-password-button"
                    type="button"
                    onClick={() => setShowPassword((state) => !state)}
                  >
                    <img src="/images/showpassword.png" alt="" />
                    {showPassword && <span className="slash"></span>}
                  </button>
                  {errors.password && <ValidationError error={errors.password} />}
                </div>
                <div className="login-form-field-wrapper">
                  <label
                    htmlFor="password_confirmation"
                    className="login-form-field-label"
                  >
                    Ponovite novu lozinku:*
                  </label>
                  <Field
                    name="password_confirmation"
                    type={showRepeatPassword ? "text" : "password"}
                    className="login-textfield"
                  />
                  <button
                    className="show-password-button"
                    type="button"
                    onClick={() => setShowRepeatPassword((state) => !state)}
                  >
                    <img src="/images/showpassword.png" alt="" />
                    {showRepeatPassword && <span className="slash"></span>}
                  </button>
                  {errors.password_confirmation && (
                    <ValidationError error={errors.password_confirmation} />
                  )}
                </div>

                <button type="submit" className="login-form-button">
                  Promeni lozinku
                </button>
              </Form>
            )}
          </Formik>
          <Loading isLoading={loading} />
        </>
      )}
      {success && (
        <div className="text-regular">
          <p style={{ fontWeight: "700" }}>Uspešno ste promenili lozinku.</p>
          <p>Pri sledećoj prijavi koristite novu lozinku.</p>
        </div>
      )}
    </div>
  );
}
